import React from 'react';
// import { useLocation } from 'react-router-dom';
import { Content, Lesson } from '../../../../../types';
import SectionContent from '../section-content/SectionContent';
import { useCourseContent } from '../../../../../hooks/useCourseContent';
import { LastVisitedLessonContentFragment, SectionFragment } from '@api/graphql-codegen'

type Props = {
  contents: Content[];
  lesson?: Lesson | SectionFragment;
  lastVisitedLesson?: LastVisitedLessonContentFragment;
  closeNav?: () => void;
  isPreparation?: boolean;
  selectedModuleIndex?: number;
};

function SectionContents(props: Props) {
  const { contents, lesson, lastVisitedLesson, closeNav, isPreparation, selectedModuleIndex=0 } = props;
  const { content: selectedContent, lesson: selectedLesson, section: selectedSection, isNewLessonLayout } = useCourseContent();
  // const { pathname } = useLocation();
  // const [getSkills, { data }] = useSkillsLazyQuery();
  // useEffect(() => {
  //   if (isParentApp && pathname.startsWith('/parent/specialProgram')) {
  //     getSkills();
  //   }
  // }, [getSkills, isParentApp, pathname])

  // const otherSkills = useMemo(() => (data?.skills || []).filter(s => s?.id !== selectedContent?.id), [data?.skills, selectedContent?.id])
  return (
    <>
      {(contents || []).map((content, index) => {
        const sectionSelected = selectedContent?.id === content.id && (isPreparation || (selectedSection ? selectedSection?.id === lesson?.id : selectedLesson?.id === lesson?.id));
        return <SectionContent lastVisitedLesson={lastVisitedLesson} lesson={lesson} key={content.id} selected={sectionSelected || (isNewLessonLayout && index <= selectedModuleIndex)} content={content as Content} closeNav={closeNav} />
      })}
      {/* {isParentApp && otherSkills && otherSkills.length > 0 && otherSkills.map(content => {
        const sectionSelected = selectedContent?.id === content?.id && selectedLesson?.id === lesson.id;
        return <SectionContent lastVisitedLesson={lastVisitedLesson} lesson={lesson} key={content?.id} selected={sectionSelected} content={content as unknown as Content}/>
      })} */}
    </>
  );
}

export default SectionContents;
